<div class="filter__dropdown filter__dropdown--view">
  <button mat-button [matMenuTriggerFor]="topMenu" [disabled]="!isLoaded" class="filter__dropdown-button"
    [matTooltipDisabled]="!isNameTooLong" [matTooltip]="selectedView?.name || ''" matTooltipPosition="above"
    id="btn_gridView">
    <span *ngIf="!isLoaded">
      {{ 'gridFilter.loading' | translate }}
    </span>
    <span class="text-gray" *ngIf="isLoaded && !viewsList.length">
      {{ 'gridFilter.noViews' | translate }}
    </span>
    <span *ngIf="isLoaded && viewsList.length">
      {{ selectedView?.name | slice:0:15 }}{{ isNameTooLong ? '...' : '' }}
    </span>
    <icon name="arrow_drop_down" class="margin-start-s"></icon>
  </button>
  <mat-menu #topMenu="matMenu" class="filter-menu filter-menu--with-overlay no-margin">
    <ng-container *ngFor="let item of viewsList; let i = index">
      <button mat-menu-item (click)="onClickItem(item)" [matMenuTriggerFor]="submenu" class="view-menu-item"
        [ngClass]="{'mat-menu-item--selected': item.id === selectedView?.id}" [id]="'btn_gridView' + i">
        <span class="filter-menu-item-text">
          {{ item.name }}
        </span>
        <span class="view-access-level">
          {{getUserAccessLevel(item)}}
        </span>
      </button>
      <mat-menu #submenu="matMenu" class="filter-menu filter-menu--more-options">
        @if(item.owner === authService.currentUserEmail) {
        <button mat-menu-item (click)="shareView(item)" [id]="'btn_gridShareView' + i">
          <icon name="share" class="padding-end-s"></icon>
          {{'gridFilter.shareView' | translate}}
        </button>
        <button mat-menu-item (click)="editViewName(item)" [id]="'btn_gridEditView' + i">
          <icon name="edit" class="padding-end-s"></icon>
          {{'gridFilter.renameView' | translate}}
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item class="menu-item-error" (click)="deleteAgGridFilterView(item.id)"
          [id]="'btn_gridDeleteView' + i">
          <icon name="delete" class="menu-item-error--icon padding-end-s"></icon>
          {{'gridFilter.deleteview' | translate}}
        </button>
        }
        @else {
        <button mat-menu-item [id]="'btn_gridShareView' + i"
          matTooltip="{{'gridFilter.youDontHavePermissions' | translate}}" matTooltipPosition="after" disabled>
          <icon name="share" class="padding-end-s"></icon>
          {{'gridFilter.shareView' | translate}}
          <icon name="lock" class="filter-menu__icon margin-start-auto"></icon>
        </button>
        <button mat-menu-item [id]="'btn_gridEditView' + i"
          matTooltip="{{'gridFilter.youDontHavePermissions' | translate}}" matTooltipPosition="after" disabled>
          <icon name="edit" class="padding-end-s"></icon>
          {{'gridFilter.renameView' | translate}}
          <icon name="lock" class="filter-menu__icon margin-start-auto"></icon>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item [id]="'btn_gridDeleteView' + i"
          matTooltip="{{'gridFilter.youDontHavePermissions' | translate}}" matTooltipPosition="after" disabled>
          <icon name="delete" class="padding-end-s"></icon>
          {{'gridFilter.deleteview' | translate}}
          <icon name="lock" class="filter-menu__icon margin-start-auto"></icon>
        </button>
        }
      </mat-menu>
    </ng-container>
    <mat-divider *ngIf="viewsList.length"></mat-divider>
    @if(permissions.CreateTableView | hasPermission) {
    <button mat-menu-item id="btn_gridCreateView" class="d-flex justify-content-between" (click)="createNew()">
      <span class="typo-color--primary">{{'gridFilter.createView' | translate}}</span>
      <icon name="add" color="primary" class="filter-menu__icon"></icon>
    </button>
    }
    @else {
    <button mat-menu-item id="btn_gridCreateView" class="d-flex justify-content-between"
      matTooltip="{{'gridFilter.youDontHavePermissions' | translate}}" matTooltipPosition="after" disabled>
      <span>{{'gridFilter.createView' | translate}}</span>
      <icon name="lock" class="filter-menu__icon"></icon>
    </button>
    }
  </mat-menu>
  <div class="filter-menu filter__dropdown--view--container m-0" *ngIf="isCreate">
    <span class="filter-menu--with-overlay"></span>
    <div class="filter__dropdown filter__dropdown--view--popup">
      <form>
        <mat-form-field class="filter-view-input--container margin-bottom-none" appearance="outline"
          [ngClass]="{'filter-view-input--container--focus': isFocusInput}">
          <input matInput [autofocus]="true" required (focus)="isFocusInput = true" (blur)="isFocusInput = false"
            placeholder="{{'gridFilter.enterViewName' | translate}}" name="viewName" class="filter-view-input"
            [(ngModel)]="viewName" type="text" id="textbox_viewName" />
        </mat-form-field>
        <div class="d-flex justify-content-center align-items-center margin-top-base">
          <button mat-stroked-button *ngIf="!editId" color="primary" type="submit" class="margin-end-s"
            [disabled]="isSaving" (click)="createView()" id="btn_saveViewName">
            {{(isSaving ? 'gridFilter.saving':'gridFilter.saveView') | translate}}
          </button>
          <button mat-stroked-button *ngIf="editId" color="primary" type="submit" class="margin-end-s"
            [disabled]="isSaving" (click)="renameView(viewName)" id="btn_saveViewName">
            {{(isSaving ? 'gridFilter.updating':'gridFilter.updateView') | translate}}
          </button>
          <button mat-button color="warn" type="button" (click)="isCreate = false" id="btn_cancelViewName"
            [disabled]="isSaving">
            {{'gridFilter.cancel' | translate}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>